// (?!\s+$)     - whole string is only spaces
// (?!.*\s{2,}) - two or more consecutive spaces
// (?!.*\d)     - any digit
// [\p{L}\s\-.]+ - allows letters, spaces, hyphens, dots, one or more times
export const nicknameRegex = /^((?!\s+$)(?!.*\s{2,})(?!.*\d)[\p{L}\s\-.]+)$/u
